"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var PregressBar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PregressBar, _React$Component);

  function PregressBar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PregressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PregressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setScoreAndStyle = function (scorePercentage) {
      var progressBarNode = (0, _reactDom.findDOMNode)(_this.refs.progressBar); // Using setTimeout ensures the bar animates

      setTimeout(function () {
        // Set the width based on score
        progressBarNode.style.width = scorePercentage + "%";
      }, 1);
    };

    return _this;
  }

  (0, _createClass2.default)(PregressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScoreAndStyle(this.props.scorePercentage);
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "bar-wrapper"
      }, _react.default.createElement("div", {
        className: "bar"
      }), _react.default.createElement("div", {
        className: "bar progress-bar",
        ref: "progressBar"
      }));
    }
  }]);
  return PregressBar;
}(_react.default.Component);

exports.default = PregressBar;
PregressBar.propTypes = {
  scorePercentage: _propTypes.default.number.isRequired
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/ProgressBar.js
// module id = 152
// module chunks = 0